import $ from 'jquery';
import * as originalFileInput from '@elements/file-input';

export function initInScope($scope) {
    // First, initialize the original file input functionality
    originalFileInput.initInScope($scope);

    // Then add the missing click handler to trigger file dialog
    $scope.find('.js-file-input').on('click', function (e) {
        // Prevent clicking on the hidden input from triggering this
        if (!$(e.target).is('input[type="file"]')) {
            $(this).find('input[type="file"]').trigger('click');
        }
    });

    // Optional: Make cursor pointer on hover to indicate it's clickable
    $scope.find('.js-file-input').css('cursor', 'pointer');
}
